/* Virtual product inquiries. No checkout, payment, automatic message or server submission. */

(() => {

  'use strict';

  const KEY = 'zhida-maison-v2-quote', PROJECT = 'zhida-maison-v2-project', MAX = 999999;

  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const str = (s, max = 6000) => String(s ?? '').slice(0, max);

  const esc = s => str(s, 20000).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const read = (k, fallback) => { try { return JSON.parse(localStorage.getItem(k)) ?? fallback; } catch { return fallback; } };

  const products = () => window.ZhidaInquiryData?.products || [];

  const product = id => products().find(p => p.id === id);

  const uid = () => window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2);

  const integer = (v, fallback = 1) => Math.min(MAX, Math.max(1, Math.floor(Number(v) || fallback)));

  function limits(p = {}) { const min = integer(p.min_quantity), step = integer(p.quantity_step); return { min, step, max: min + Math.floor((MAX - min) / step) * step }; }

  function quantity(p, v) { const {min, step, max} = limits(p); return Math.min(max, min + Math.ceil((Math.max(min, integer(v, min)) - min) / step) * step); }

  const grade = g => ['3','4','5','advise'].includes(String(g)) ? String(g) : '4';

  const gradeText = g => ({'3':'3-star / Standard','4':'4-star / Premium','5':'5-star / Luxury','advise':'Please recommend'})[grade(g)];

  const intentText = v => ({bulk:'Bulk purchase',sample:'Sample request',recommend:'Help me choose'})[v] || 'Bulk purchase';

  function imageURL(v) { try { const u = new URL(v || '/assets/placeholder.svg', location.origin); return /^https?:$/.test(u.protocol) ? u.href : ''; } catch { return ''; } }

  function route(view, params = {}, publicLink = false) {

    const u = new URL((document.body.dataset.root || '/') + 'pages/' + view, location.origin);

    Object.entries(params).forEach(([k,v]) => u.searchParams.set(k, v));

    const preview = new URLSearchParams(location.search).get('preview_theme_id');

    if (preview && !publicLink) u.searchParams.set('preview_theme_id', preview);

    return publicLink ? u.href : u.pathname + u.search;

  }

  const snapshot = p => ({name:str(p.en,180),code:str(p.code,100),unit:str(p.unit || 'pieces',80),image:imageURL(p.image)});

  function normalize(x) {

    if (!x || typeof x.id !== 'string') return null;

    const p = product(x.id), saved = x.snapshot || {};

    return { uid:str(x.uid || uid(),100), id:x.id, qty:integer(x.qty), grade:grade(x.grade),

      options:Array.isArray(x.options) ? x.options.filter(o => o && o.label && o.value !== undefined).slice(0,30).map(o => ({label:str(o.label,180),value:str(o.value,1000)})) : [],

      notes:str(x.notes ?? x.spec ?? ''), intent:['sample','recommend'].includes(x.intent) ? x.intent : 'bulk',

      snapshot:p ? snapshot(p) : {name:str(saved.name || x.id,180),code:str(saved.code || x.id,100),unit:str(saved.unit || 'pieces',80),image:imageURL(saved.image)} };

  }

  let list = (Array.isArray(read(KEY,[])) ? read(KEY,[]) : []).map(normalize).filter(Boolean);

  // Old lists had no row key. Never reuse a key when a corrupt/hand-edited list has duplicates.

  { const seen = new Set(); list.forEach(x => { if (seen.has(x.uid)) x.uid = uid(); seen.add(x.uid); }); }

  let project = read(PROJECT,{}); if (!project || typeof project !== 'object' || Array.isArray(project)) project = {};

  let detailID = '', editedUID = '', toastTimer;

  function notice(message) { const n = $('.toast'); if (!n) return; n.textContent = message; n.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(() => n.hidden = true, 5000); }

  function store(key, data) {

    try { localStorage.setItem(key,JSON.stringify(data)); return true; }

    catch {

      if (!$('.zi-storage-warning')) { const n = document.createElement('p'); n.className = 'zi-storage-warning'; n.setAttribute('role','alert'); n.textContent = 'This browser cannot save your inquiry. Keep this tab open and copy or download your list before leaving.'; document.body.append(n); }

      return false;

    }

  }

  function persist(renderNow = true) { store(KEY,list); if (renderNow) render(); document.dispatchEvent(new CustomEvent('zhida:quote:updated')); }

  function show(id) {

    const dialog = $(id); if (!dialog) return;

    $$('dialog[open]').forEach(d => { if (d !== dialog) d.close(); });

    if (!dialog.open) dialog.showModal(); document.body.style.overflow = 'hidden';

  }

  function saveProject() {

    ['company','country','purpose','date','notes'].forEach(k => { const el = $('#quote-' + k); if (el) project[k] = str(el.value, k === 'notes' ? 3000 : 180); });

    store(PROJECT,project);

  }

  function hydrateProject() { ['company','country','purpose','date','notes'].forEach(k => { const el = $('#quote-' + k); if (el && typeof project[k] === 'string' && !el.dataset.ziHydrated) { el.value = project[k]; el.dataset.ziHydrated = 'true'; } }); }

  function definitions(p) {

    const lines = v => String(v || '').split(/\r?\n/).map(x => x.trim());

    const names = lines(p.option_labels), choices = lines(p.option_choices), types = lines(p.option_types), required = lines(p.required_options);

    let defs = names.map((label,i) => ({label, type:types[i] || 'select', choices:(choices[i] || '').split('|').map(x => x.trim()).filter(Boolean), required:required.includes(label)})).filter(d => d.label).slice(0,30);

    // Compatibility with option blocks already saved in this theme's detail section.

    if (!defs.length) $$('[id^="zhida-product-option-config-"]').forEach(node => {

      try { const config = JSON.parse(node.textContent); (Array.isArray(config) ? config : (config.options || [])).forEach(d => {

        if (d.label && [p.id,p.code,p.category,'category:'+p.category,'all',''].includes(d.product_key || '') && !defs.some(o => o.label === d.label)) defs.push({...d,choices:Array.isArray(d.choices)?d.choices:str(d.choices).split(/\r?\n|\|/).filter(Boolean)});

      }); } catch { /* optional legacy configuration */ }

    });

    return defs.slice(0,30).map(d => ({...d,type:({radio:'buttons',checkbox:'multi'})[d.type] || (['select','buttons','multi','text'].includes(d.type)?d.type:'select')}));

  }

  function optionHTML(d,i,values = []) {

    // The empty option already offers a recommendation for optional fields.
    if (!d.required) d = {...d, choices:d.choices.filter(c => c.toLowerCase() !== 'please recommend')};

    const value = values.find(o => o.label === d.label)?.value || '', id = 'zi-option-' + i;

    const heading = esc(d.label) + (d.required ? ' <span aria-label="required">*</span>' : '');

    const attr = `data-zi-option="${i}" data-zi-label="${esc(d.label)}"`, help = d.help ? `<small class="zi-option-help">${esc(d.help)}</small>` : '';

    if (d.type === 'text' || !d.choices.length) return `<label class="zi-field" for="${id}">${heading}<input id="${id}" ${attr} maxlength="1000" ${d.required?'required':''} value="${esc(value)}" placeholder="Enter your requirements">${help}</label>`;

    if (d.type === 'multi' || d.type === 'buttons') {

      const multi = d.type === 'multi', selected = multi ? value.split('; ') : [value];

      return `<fieldset class="zi-field zi-choice-group" data-zi-group="${i}" ${multi && d.required?'data-zi-required-group':''}><legend>${heading}</legend>${d.choices.map((c,j) => `<label class="zi-choice"><input type="${multi?'checkbox':'radio'}" name="zi-option-${i}" id="${id}-${j}" ${attr} value="${esc(c)}" ${selected.includes(c)?'checked':''} ${!multi && d.required?'required':''}><span>${esc(c)}</span></label>`).join('')}${!multi && !d.required?`<label class="zi-choice"><input type="radio" name="zi-option-${i}" ${attr} value="" ${!value?'checked':''}><span>Please recommend</span></label>`:''}${help}</fieldset>`;

    }

    return `<label class="zi-field" for="${id}">${heading}<select id="${id}" ${attr} ${d.required?'required':''}><option value="">${d.required?'Choose an option':'Please recommend'}</option>${d.choices.map(c => `<option value="${esc(c)}" ${value===c?'selected':''}>${esc(c)}</option>`).join('')}</select>${help}</label>`;

  }

  function selectedOptions(form) {

    const options = [], groups = new Map();

    $$('[data-zi-option]',form).forEach(el => { if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return; const value = el.value.trim(); if (!value) return; const key = el.dataset.ziOption; if (!groups.has(key)) groups.set(key,{label:el.dataset.ziLabel,values:[]}); groups.get(key).values.push(value); });

    groups.forEach(o => options.push({label:o.label,value:o.values.join('; ')})); return options;

  }

  function currentOptions(form) {
    return selectedOptions(form).concat($$('[data-zi-guide]',form).filter(el => el.value.trim()).map(el => ({label:el.dataset.ziGuide,value:el.value.trim()})));
  }

  function detailConfig() { try { return JSON.parse($('#zi-detail-config')?.textContent || '{}'); } catch { return {}; } }

  function updateSelection() {
    const form = $('#zi-add-product'); if (!form) return;
    $$('[data-zi-required-group]',form).forEach(group => { const checks = $$('input[type=checkbox]',group); if (checks.length) checks[0].setCustomValidity(checks.some(c => c.checked)?'':'Select at least one option.'); });
    const p = product(form.dataset.id); if (!p) return;
    const chosen = selectedOptions(form), options = currentOptions(form);
    const unresolved = definitions(p).filter(d => !chosen.some(o => o.label === d.label));
    const out = $('#zi-selection-summary');
    if (out) out.innerHTML = `<p class="eyebrow">Your inquiry configuration</p><dl>${options.map(o => `<div><dt>${esc(o.label)}</dt><dd>${esc(o.value)}</dd></div>`).join('')}<div><dt>Target tier</dt><dd>${esc(gradeText(form.elements.grade.value))}</dd></div><div><dt>Request</dt><dd>${esc(intentText(form.elements.intent.value))}</dd></div><div><dt>Quantity</dt><dd>${esc(form.elements.quantity.value)} ${esc(p.unit || 'pieces')}</dd></div></dl>${unresolved.length?`<p class="small">Please recommend: ${esc(unresolved.map(d=>d.label).join(', '))}.</p>`:''}<p class="small">${options.some(o=>/custom|embroidery|branding/i.test(o.value))?'Custom dimensions, finishing or branding need feasibility, sample and MOQ confirmation.':'A sourcing request, not a stock reservation. Final specification and pricing are confirmed with your quotation.'}</p>`;
    const hint=$('[data-zi-tier-hint]',form),g=form.elements.grade.value;
    if(hint) hint.textContent=p['tier_'+g] || ({'3':'A starting point for value-led sourcing. Tell us your laundry and usage requirements.','4':'A starting point for balancing guest comfort and day-to-day operating needs.','5':'A starting point for elevated finish and guest experience. Confirm the exact material and construction.','advise':'We will discuss suitable options around your property, usage and budget.'})[g];
    const question=$('[data-zi-question]',form);
    if(question){const text=['Hello, I would like advice about '+p.en+' ('+p.code+').','Product: '+route('item',{item:p.id},true),...options.map(o=>o.label+': '+o.value),'Target tier: '+gradeText(g),'Quantity: '+form.elements.quantity.value+' '+(p.unit||'pieces'),form.elements.notes.value.trim()?'Notes: '+form.elements.notes.value.trim():'','Please help me confirm suitable specifications and sample options.'].filter(Boolean).join('\n');question.dataset.ziMessage=text;const phone=String(document.body.dataset.wa||'').replace(/\D/g,'');question.href=`https://wa.me/${phone}?text=${encodeURIComponent(text)}`;}
  }

  function setMode(mode) {
    const form=$('#zi-add-product'); if(!form)return;
    form.dataset.mode=mode;
    $$('[data-zi-mode]',form).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.ziMode===mode)));
    $('[data-zi-guide-panel]',form).hidden=mode!=='guided';
    const specs=$('[data-zi-specifications]',form);specs.open=mode!=='guided';
    if(mode==='guided')form.elements.intent.value='recommend';
    else if(form.elements.intent.value==='recommend')form.elements.intent.value='bulk';
    updateSelection();
  }

  function renderDetail() {

    const box = $('#product-detail'); if (!box) return;

    const params = new URLSearchParams(location.search), id = params.get('item'), p = product(id);

    if (!p) { box.innerHTML = `<div class="empty-state"><h1>${id?'This product is currently unavailable.':'Choose a product to configure.'}</h1><p>Browse the range to select specifications and build your inquiry.</p><a class="button" href="${esc(route('catalog'))}">Explore products</a></div>`; return; }

    const current = $('#zi-add-product'), preserved = current && detailID === id ? {options:currentOptions(current),notes:current.elements.notes.value,qty:current.elements.quantity.value,grade:current.elements.grade.value,intent:current.elements.intent.value} : null;

    editedUID = params.get('line') || ''; const existing = list.find(x => x.uid === editedUID && x.id === id); if (!existing) editedUID = '';

    const values = preserved || existing || {options:[],notes:'',qty:quantity(p,p.default_quantity),grade:grade(p.grade),intent:'bulk'};

    detailID = id; const imgs = [...new Set([p.image,...(p.gallery || [])].filter(Boolean).map(imageURL).filter(Boolean))];

    const facts = str(p.facts).split(/\r?\n/).map(line => { const split = line.indexOf('|'); return split < 0 ? null : {label:line.slice(0,split).trim(),value:line.slice(split+1).trim()}; }).filter(f => f?.label && f.value);

    const notes = [['Minimum order',p.moq_note],['Samples',p.sample_note],['Lead time',p.lead_time]].filter(([,v]) => v);

    const lim = limits(p), config=detailConfig();
    const guideValue=label=>esc(values.options.find(o=>o.label===label)?.value||'');

    box.innerHTML = `<div class="zi-gallery"><button type="button" class="detail-image" data-zoom="${esc(imgs[0])}" aria-label="Enlarge product image"><img id="zi-main-image" src="${esc(imgs[0])}" width="1000" height="1000" alt="${esc(p.en)}"></button>${imgs.length>1?`<div class="zi-thumbnails" role="group" aria-label="Product images">${imgs.map((url,i) => `<button type="button" data-zi-image="${esc(url)}" aria-pressed="${i===0}"><img src="${esc(url)}" width="100" height="100" alt="${esc(p.en)} — view ${i+1}"></button>`).join('')}</div>`:''}${p.demo?'<p class="small zi-demo-note">Demonstration concept / illustrative AI-generated image. Actual product details require confirmation.</p>':''}${config.show_buying_notes!==false?`<div class="zi-buying-notes"><h2>Before you decide</h2>${[['What is included?',p.included_note || definitions(p).find(d=>/set components|combination|contents/i.test(d.label))?.choices.join(' / ') || 'Confirm the selected item, dimensions and included pieces with your quotation. Room furnishings and styling accessories are not automatically included.'],...notes,['Customisation & packaging',p.custom_note || 'Share dimensions, embroidery, labels and packing requirements. Feasibility, quantities and an approval sample are discussed before confirmation.'],['Delivery planning',p.delivery_note || 'Tell us the destination and requested date. Freight, packing units and the delivery arrangement are confirmed in your quotation.']].map(([title,text])=>`<details><summary>${esc(title)}</summary><p>${esc(text)}</p></details>`).join('')}<a class="text-link" href="${esc(route('samples'))}">How sample approval works ↗</a></div>`:''}</div>

      <div class="detail-copy zi-detail-copy"><a class="detail-back" href="${esc(route('catalog',{category:p.category}))}">← All products</a><p class="eyebrow">${esc(p.code)} · ZHIDA SUPPLY</p><h1>${esc(p.en)}</h1><p>${esc(p.description)}</p>${facts.length?`<dl class="zi-facts">${facts.map(f => `<div><dt>${esc(f.label)}</dt><dd>${esc(f.value)}</dd></div>`).join('')}</dl>`:''}${notes.length?`<dl class="zi-facts zi-commercial">${notes.map(([a,b]) => `<div><dt>${a}</dt><dd>${esc(b)}</dd></div>`).join('')}</dl>`:''}

      <form id="zi-add-product" data-id="${esc(id)}" data-mode="expert"><h2 class="zi-form-heading">Configure your inquiry</h2>
      ${config.show_guidance!==false?`<div class="zi-mode-switch" role="group" aria-label="Choose how to configure"><button type="button" data-zi-mode="expert" aria-pressed="true">I know my specifications</button><button type="button" data-zi-mode="guided" aria-pressed="false">Help me choose</button></div>`:''}
      <div class="zi-guide-panel" data-zi-guide-panel hidden><p>Share what you know. Leave technical choices to discuss with our sourcing team.</p><div class="zi-options"><label class="zi-field" for="zi-property">Property type<select id="zi-property" data-zi-guide="Property type"><option value="">Please recommend</option>${['Hotel','Boutique hotel','Serviced apartment','Resort','Other'].map(v=>`<option ${guideValue('Property type')===v?'selected':''}>${v}</option>`).join('')}</select></label><label class="zi-field" for="zi-priority">Main purchasing priority<select id="zi-priority" data-zi-guide="Purchasing priority"><option value="">Discuss with me</option>${['Everyday operation','Guest comfort','Premium presentation','Replacement programme','New opening'].map(v=>`<option ${guideValue('Purchasing priority')===v?'selected':''}>${v}</option>`).join('')}</select></label><label class="zi-field" for="zi-budget">Target budget (optional)<input id="zi-budget" data-zi-guide="Target budget" maxlength="180" placeholder="Amount, currency and unit" value="${guideValue('Target budget')}"></label><label class="zi-field" for="zi-laundry">Usage / laundry needs (optional)<input id="zi-laundry" data-zi-guide="Usage / laundry needs" maxlength="500" placeholder="Commercial laundry, daily use…" value="${guideValue('Usage / laundry needs')}"></label></div></div>
      <details class="zi-specifications" data-zi-specifications open><summary>Product specifications <span>Choose options or request advice</span></summary><div class="zi-options">${definitions(p).map((d,i) => optionHTML(d,i,values.options)).join('')}</div></details>

      <label class="zi-field" for="zi-grade">Requested quality tier<select id="zi-grade" name="grade">${['3','4','5','advise'].map(g => `<option value="${g}" ${String(values.grade)===g?'selected':''}>${esc(gradeText(g))}</option>`).join('')}</select></label>

      ${[3,4,5].some(g => p['tier_'+g])?`<details class="zi-tier-details"><summary>Compare target tiers</summary>${[3,4,5].filter(g => p['tier_'+g]).map(g => `<p><strong>${gradeText(g)}</strong><br>${esc(p['tier_'+g])}</p>`).join('')}</details>`:''}

      <p class="zi-tier-hint" data-zi-tier-hint></p><p class="detail-note">A requested sourcing tier, not a hotel rating or product certification. Materials and specifications will be confirmed in your quotation.</p>

      <label class="zi-field" for="zi-intent">Request type<select id="zi-intent" name="intent">${['bulk','sample','recommend'].map(v => `<option value="${v}" ${values.intent===v?'selected':''}>${intentText(v)}</option>`).join('')}</select></label>

      <label class="zi-field" for="zi-quantity">Requested quantity (${esc(p.unit || 'pieces')})<span class="zi-quantity"><button type="button" data-zi-step="-1" aria-label="Decrease quantity">−</button><input id="zi-quantity" name="quantity" type="number" min="${lim.min}" max="${lim.max}" step="${lim.step}" required value="${esc(values.qty)}"><button type="button" data-zi-step="1" aria-label="Increase quantity">+</button></span></label>

      <label class="zi-field" for="zi-notes">Additional requirements (optional)<textarea id="zi-notes" name="notes" rows="3" maxlength="6000" placeholder="Custom dimensions, branding or packaging…">${esc(values.notes)}</textarea></label>

      <div id="zi-selection-summary" class="zi-selection-summary" aria-live="polite" aria-atomic="true"></div><button class="button full" type="submit">${editedUID?'Save changes to inquiry':'Add to inquiry list'} +</button>${!editedUID && config.show_sample!==false?`<button type="button" class="button secondary full" data-zi-sample>${esc(config.sample_label || 'Request a sample')} ↗</button>`:''}${config.show_question!==false?`<a class="zi-product-question text-link" data-zi-question target="_blank" rel="noopener noreferrer">${esc(config.question_label || 'Ask about this product on WhatsApp')} ↗</a>`:''}<p class="small zi-action-note">${esc(config.action_note || 'No payment required. Review your list before sending. Sample charges and delivery are confirmed separately.')}</p>${editedUID?`<a class="zi-edit-return href="${esc(route('quote'))}">Return to inquiry list</a>`:''}</form><p class="detail-note">${esc(p.spec || 'Final specifications, MOQ, sample availability, pricing and delivery will be confirmed with your quotation.')}</p></div>`;

    if(values.intent==='recommend' && config.show_guidance!==false)setMode('guided');else updateSelection();

  }

  function signature(x) { return JSON.stringify([x.id,x.grade,x.intent,x.notes,[...x.options].map(o => [o.label,o.value]).sort((a,b)=>a[0].localeCompare(b[0]) || a[1].localeCompare(b[1]))]); }

  function add({id,spec='',notes,amount=1,qty,grade:g='4',options=[],intent='bulk',editUID} = {}) {

    const p = product(id); if (!p) { notice('This product is no longer available.'); return false; }

    const count = Number(qty ?? amount), lim = limits(p);

    if (!Number.isInteger(count) || count < lim.min || count > lim.max || (count - lim.min) % lim.step !== 0) { notice(`Enter a quantity from ${lim.min}, in increments of ${lim.step}.`); return false; }

    const line = normalize({id,qty:count,grade:g,options,notes:notes ?? spec,intent});

    // Catalog quick-add must take required specifications through the detail page.

    if (definitions(p).some(d => d.required && !line.options.some(o => o.label === d.label && o.value.trim()))) { notice('Choose the required specifications on the product page first.'); return false; }

    const existing = list.findIndex(x => x.uid === editUID && x.id === id);

    if (editUID && existing < 0) { notice('This inquiry line was removed. Add it as a new item.'); return false; }

    const same = list.find(x => x.uid !== editUID && signature(x) === signature(line));

    if (same && same.qty + count > lim.max) { notice('The combined quantity is too large. Please reduce it.'); return false; }

    if (same && (same.qty + count - lim.min) % lim.step !== 0) { notice('The combined quantity does not match the configured increment. Edit the existing line instead.'); return false; }

    if (same) { same.qty += count; if (existing >= 0) list.splice(existing,1); }

    else if (existing >= 0) { line.uid = editUID; list[existing] = line; }

    else list.push(line);

    persist(); notice(existing >= 0?'Inquiry updated.':'Added to your inquiry list.'); return true;

  }

  function rows(drawer = false) {

    if (!list.length) return `<div class="empty-state"><h3>Your inquiry list is empty.</h3><p>Select products and specifications to start your request.</p><a class="button" href="${esc(route('catalog'))}">Explore products</a></div>`;

    return list.map(x => {

      const p = product(x.id), s = p ? snapshot(p) : x.snapshot, lim = p ? limits(p) : {min:1,step:1,max:MAX};

      return `<article class="zi-quote-row" data-zi-row="${esc(x.uid)}"><img src="${esc(s.image)}" width="110" height="130" loading="lazy" alt="${esc(s.name)}"><div class="zi-row-copy"><p class="small">${esc(s.code)}</p><h3>${esc(s.name)}</h3>${!p?'<p class="small">No longer listed. We will confirm availability.</p>':''}<dl class="zi-row-specs">${x.options.map(o => `<div><dt>${esc(o.label)}</dt><dd>${esc(o.value)}</dd></div>`).join('')}<div><dt>Target tier</dt><dd>${esc(gradeText(x.grade))}</dd></div><div><dt>Request</dt><dd>${intentText(x.intent)}</dd></div></dl>${x.notes?`<p class="zi-row-notes">${esc(x.notes)}</p>`:''}<div class="zi-row-actions"><label>Quantity · ${esc(s.unit)}<input type="number" min="${lim.min}" max="${lim.max}" step="${lim.step}" required data-zi-qty="${esc(x.uid)}" value="${x.qty}"></label>${p?`<a class="text-link" href="${esc(route('item',{item:x.id,line:x.uid}))}">Edit specifications</a>`:''}<button type="button" class="text-link" data-zi-remove="${esc(x.uid)}">Remove</button></div></div></article>`;

    }).join('') + (!drawer?`<p class="quote-total">${list.length} product configuration${list.length===1?'':'s'} in your inquiry</p><a class="text-link" href="${esc(route('catalog'))}">+ Add more products</a>`:'');

  }

  function render() {

    $$('.quote-count').forEach(n => n.textContent = list.length);

    if ($('#drawer-items')) $('#drawer-items').innerHTML = rows(true);

    if ($('#quote-page-items')) $('#quote-page-items').innerHTML = rows(false);

    $$('[data-preview-inquiry],[data-direct-wa],[data-zi-copy-list],[data-zi-download-list]').forEach(b => b.disabled = !list.length);

    hydrateProject();

  }

  function message() {

    saveProject(); let settings = {}; try { settings = JSON.parse($('#v-b2b-settings')?.textContent || '{}'); } catch { /* defaults */ }

    const text = [settings.opening || 'Hello, I would like a quotation from ZHIDA SUPPLY.',''];

    list.forEach((x,i) => { const p = product(x.id), s = p ? snapshot(p) : x.snapshot;

      text.push(`${i+1}. ${s.name} (${s.code})`,`Quantity: ${x.qty} ${s.unit}`,`Target tier: ${gradeText(x.grade)}`,`Request type: ${intentText(x.intent)}`);

      x.options.forEach(o => text.push(o.label + ': ' + o.value));

      if (x.notes) text.push('Additional requirements: ' + x.notes);

      if (p?.demo) text.push('Demonstration selection — please confirm the actual product.');

      if (!p) text.push('Availability needs confirmation.');

      text.push('Product: ' + route('item',{item:x.id},true),'');

    });

    [['company','Company / property'],['country','Destination country'],['purpose','Project type'],['date','Requested delivery date'],['notes','Project notes']].forEach(([k,label]) => { if (project[k]) text.push(label + ': ' + project[k]); });

    text.push('',settings.closing || 'Please confirm specifications, MOQ, sample options, pricing and delivery.'); return text.join('\n');

  }

  function preview(text = message(), long = false) {

    const input = $('#inquiry-text'); if (!input) return; input.value = text;

    $('#zi-long-notice').hidden = !long;

    $('#zi-open-short').hidden = !long;

    $('#zi-wa-fallback').hidden = true;

    show('#inquiry-preview');

  }

  function openWhatsApp(text = message(), short = false) {

    const phone = String(document.body.dataset.wa || '').replace(/\D/g,'');

    if (!/^[1-9]\d{6,14}$/.test(phone)) { notice('The WhatsApp contact number needs updating. Please use our email contact.'); return false; }

    if (!text.trim()) { notice('Add your inquiry message first.'); return false; }

    if (!short && encodeURIComponent(text).length > 6500) { preview(text,true); return false; }

    const content = short ? 'Hello, I have a product inquiry for ZHIDA SUPPLY. I will paste my complete inquiry list below.' : text;

    // A normal top-level new tab avoids embedding WhatsApp inside the theme editor iframe.

    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const url = mobile ? `https://wa.me/${phone}?text=${encodeURIComponent(content)}` : `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(content)}`;

    // Do not infer failure from window.open's return value with noopener (it can be null).

    window.open(url,'_blank','noopener,noreferrer');

    const fallback = $('#zi-wa-fallback'); if (fallback) { fallback.href = url; fallback.hidden = false; }

    notice('WhatsApp opens in a new tab. Review the message and send it there.'); return true;

  }

  async function copy(text = message()) {

    try { if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable'); await navigator.clipboard.writeText(text); notice('Full inquiry copied.'); return true; }

    catch { preview(text,encodeURIComponent(text).length > 6500); $('#inquiry-text').focus(); $('#inquiry-text').select(); notice('Copy the selected message using Ctrl+C, or use Download list.'); return false; }

  }

  function download(text = message()) {

    const url = URL.createObjectURL(new Blob([text],{type:'text/plain;charset=utf-8'})), a = document.createElement('a');

    a.href = url; a.download = 'ZHIDA-SUPPLY-inquiry.txt'; a.click(); setTimeout(() => URL.revokeObjectURL(url),1000);

  }

  document.addEventListener('submit',e => {

    if (e.target.id !== 'zi-add-product') return;

    e.preventDefault(); const form = e.target; updateSelection(); if (!form.checkValidity()) { $('[data-zi-specifications]',form).open=true; form.reportValidity(); return; }

    if (add({id:form.dataset.id,amount:Number(form.elements.quantity.value),grade:form.elements.grade.value,intent:form.elements.intent.value,options:currentOptions(form),notes:form.elements.notes.value.trim(),editUID:editedUID || undefined})) {

      editedUID = ''; show('#quote-drawer');

      // A second click after editing must not silently append the same edited amount again.

      if (new URLSearchParams(location.search).has('line')) { const u = new URL(location.href); u.searchParams.delete('line'); history.replaceState(null,'',u); }

      const submit = form.querySelector('[type=submit]'); submit.textContent = 'Add to inquiry list +';

    }

  });

  document.addEventListener('click',e => {

    const b = e.target.closest('button,a'); if (!b) return;

    if (b.dataset.ziStep) { const input = $('#zi-quantity'), p = product(detailID); input.value = quantity(p,Number(input.value) + Number(b.dataset.ziStep) * limits(p).step); updateSelection(); }

    if (b.matches('[data-zi-mode]')) setMode(b.dataset.ziMode);
    if (b.matches('[data-zi-sample]')) { const form=$('#zi-add-product');form.elements.intent.value='sample';form.elements.quantity.value=limits(product(detailID)).min;updateSelection();if(!form.checkValidity()){$('[data-zi-specifications]',form).open=true;form.reportValidity();return;}form.requestSubmit(); }
    if (b.matches('[data-zi-question]')) {e.preventDefault();updateSelection();openWhatsApp(b.dataset.ziMessage);}

    if (b.dataset.ziImage) { $('#zi-main-image').src = b.dataset.ziImage; $('#zi-main-image').closest('button').dataset.zoom = b.dataset.ziImage; $$('[data-zi-image]').forEach(n => n.setAttribute('aria-pressed',String(n===b))); }

    if (b.dataset.ziRemove) { list = list.filter(x => x.uid !== b.dataset.ziRemove); persist(); notice('Item removed.'); }

    if (b.matches('[data-zi-copy-list]')) copy();

    if (b.matches('[data-zi-download-list]')) download();

    if (b.matches('#zi-open-short')) { const text = $('#inquiry-text').value; openWhatsApp(text,true); copy(text); }

  });

  document.addEventListener('input',e => { if (e.target.closest('#zi-add-product')) updateSelection(); if (/^quote-(company|country|purpose|date|notes)$/.test(e.target.id)) saveProject(); });

  document.addEventListener('change',e => {

    const input = e.target;

    if (input.dataset.ziQty) { const line = list.find(x => x.uid === input.dataset.ziQty); if (!line) return; if (!input.checkValidity()) { input.reportValidity(); input.value = line.qty; return; } line.qty = integer(input.value); persist(); }

    if (input.closest('#zi-add-product')) updateSelection();

    if (/^quote-(company|country|purpose|date|notes)$/.test(input.id)) saveProject();

  });

  window.addEventListener('storage',e => { if (e.key === KEY) { const stored = read(KEY,[]); list = (Array.isArray(stored)?stored:[]).map(normalize).filter(Boolean); render(); } });

  document.addEventListener('zi:products:updated',() => { render(); renderDetail(); });

  if (list.length) store(KEY,list); // Save the migrated row IDs and product snapshots for future edits.

  window.ZhidaInquiry = { add, render, renderDetail, message, preview, openWhatsApp, copy, download, saveProject, limits, quantity, count:() => list.length, rows };

})();

